module.exports = __webpack_public_path__ + "static/media/speaker.1f8f2aa7.svg";